export default __webpack_public_path__ + "static/media/male-active.4ea4c136.png";